/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { goodLuckCoreDTOsReplayPlayerMetricsDtoSchema } from "./goodLuck/core/DTOs/replayPlayerMetricsDtoSchema.ts";
import { microsoftAspNetCoreMvcProblemDetailsSchema } from "./microsoft/aspNetCore/mvc/problemDetailsSchema.ts";
import { z } from "zod/v4";

export const getTournamentsTournamentidReplayMetricsPlayersUseridPathParamsSchema =
  z.object({
    tournamentId: z.string(),
    userId: z.string(),
  });

/**
 * @description OK
 */
export const getTournamentsTournamentidReplayMetricsPlayersUserid200Schema =
  z.lazy(() => goodLuckCoreDTOsReplayPlayerMetricsDtoSchema);

/**
 * @description Not Found
 */
export const getTournamentsTournamentidReplayMetricsPlayersUserid404Schema =
  z.lazy(() => microsoftAspNetCoreMvcProblemDetailsSchema);

export const getTournamentsTournamentidReplayMetricsPlayersUseridQueryResponseSchema =
  getTournamentsTournamentidReplayMetricsPlayersUserid200Schema;
